module.exports = __webpack_public_path__ + "img/HowTo.7386ef1f.svg";